import { ProductCard, ScrollReveal, StaggerContainer } from '../../components'
import { useCartContext } from '../../context'
import { products, getProductsByType, getProductById } from '../../data/products'
import type { Product } from '../../types'
import styles from './ProductsPage.module.css'

export function ProductsPage() {
  const { addItem, openCart } = useCartContext()

  const frames = getProductsByType('frame')
  const covers = getProductsByType('cover')

  const bundleOriginal = products.reduce((sum, p) => sum + p.price, 0)
  const bundlePrice = bundleOriginal * 0.85

  const formatMXN = (val: number) =>
    val.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })

  const handleAddToCart = (product: Product) => {
    addItem(product)
    openCart()
  }

  // Bundle: marco base negro + las 4 cubiertas (aplica el 15% de descuento).
  const handleAddBundle = () => {
    const bundleIds = ['frame-black-base', 'cover-red', 'cover-yellow', 'cover-green', 'cover-blue']
    bundleIds.forEach((id) => {
      const product = getProductById(id)
      if (product) addItem(product)
    })
    openCart()
  }

  return (
    <div className={styles.page}>
      <ScrollReveal>
        <header className={styles.header}>
          <h1 className={styles.title}>Nuestros Productos</h1>
          <p className={styles.subtitle}>
            Gafas sostenibles fabricadas con plástico reciclado del océano
          </p>
        </header>
      </ScrollReveal>

      <section className={styles.section} aria-labelledby="frames-heading">
        <ScrollReveal>
          <h2 id="frames-heading" className={styles.sectionTitle}>
            Marco Base
          </h2>
          <p className={styles.sectionDescription}>
            El punto de partida perfecto. Compatible con todas nuestras cubiertas magnéticas.
          </p>
        </ScrollReveal>
        <StaggerContainer className={styles.grid} staggerDelay={0.15}>
          {frames.map((product) => (
            <ProductCard key={product.id} product={product} onAddToCart={handleAddToCart} />
          ))}
        </StaggerContainer>
      </section>

      <section className={styles.section} aria-labelledby="covers-heading">
        <ScrollReveal>
          <h2 id="covers-heading" className={styles.sectionTitle}>
            Cubiertas Magnéticas
          </h2>
          <p className={styles.sectionDescription}>
            Cambia de estilo en segundos. Colecciona tus colores favoritos.
          </p>
        </ScrollReveal>
        <StaggerContainer className={styles.grid} staggerDelay={0.1}>
          {covers.map((product) => (
            <ProductCard key={product.id} product={product} onAddToCart={handleAddToCart} />
          ))}
        </StaggerContainer>
      </section>

      <ScrollReveal>
        <section className={styles.bundleSection}>
          <div className={styles.bundleContent}>
            <h2 className={styles.bundleTitle}>Bundle Completo</h2>
            <p className={styles.bundleDescription}>
              Llévate el marco base + las 4 cubiertas magnéticas con un 15% de descuento.
            </p>
            <div className={styles.bundlePricing}>
              <span className={styles.bundleOriginal}>
                {formatMXN(bundleOriginal)}
              </span>
              <span className={styles.bundlePrice}>
                {formatMXN(bundlePrice)}
              </span>
            </div>
            <button
              className={styles.bundleButton}
              onClick={handleAddBundle}
            >
              Agregar bundle al carrito
            </button>
          </div>
        </section>
      </ScrollReveal>
    </div>
  )
}

